import { useTranslation } from "react-i18next";
import React from 'react';
import {Col, Row, Spin, TableColumnsType} from "antd";
import StatisticalReportCard from "../../StatisticalReportCard";
import TableWithTotals from "../../../../../../components/table-with-totals/TableWithTotals";
import Empty from "../../../../../../components/empty";
import {handleExportReport} from "../../../../../../utils/staticReport";
import {
  exportTableCourseByIndustry,
  exportTableCourseFormatByUniversity,
  exportTableReferenceSourceByType,
  exportTableUnitFormatByIndustry,
  exportTableUniversityMultiMediaUnit,
  exportTableUniversityScomXapiUnit,
  exportTableUniversityTestByType
} from "../../../../../../service/statistical-report";
import {BarStackedChartProps, PieChart} from "../../../../../../types/static-report";
import dayjs from "dayjs";
import {staticReportStore} from "../../../../../../stores/stores";
import {createTableData} from "../../../../for-instructors/components/table/tableConvertData";

type Props = {
  loading: boolean,
  courseFormatUniversityList: BarStackedChartProps[],
  courseByIndustry: PieChart[],
  unitByIndustry: PieChart[],
  universityByTestType: PieChart[],
  universityReferenceSource: PieChart[],
  universityScormXapiUnit: PieChart[],
  universityMultiMediaUnit: PieChart[],
}


const ResourceTable = ({
                         loading, courseFormatUniversityList,
                         courseByIndustry,
                         unitByIndustry,
                         universityByTestType,
                         universityReferenceSource,
                         universityScormXapiUnit,
                         universityMultiMediaUnit
                       }: Props) => {
  const {staticReportType, filterValues, tab} = staticReportStore();
  const { t } = useTranslation();


  const exportPayload = {
    from: dayjs(filterValues.dateFrom).toISOString(),
    to: dayjs(filterValues.dateTo).toISOString(),
    courseLevelIds: filterValues?.courseLevelIds,
    industryGroupIds: filterValues?.industryGroupIds,
    courseIds: filterValues?.courseIds,
    timeUnit: filterValues.timeUnit,
    universityIds: filterValues?.universityIds,
  };


  const tableColumnCourseUnit: TableColumnsType<any> = [
    {
      title: "Khoa",
      dataIndex: "criteria",
      key: "criteria",
      render: (text: any) => <div className="font-weight-5">{text}</div>,
    },
    {
      title: t("Số lượng", "Số lượng"),
      dataIndex: "count",
      key: "count",
      align: "right"
    },
  ]

  const tableColumnQuantity: TableColumnsType<any> = [
    {
      title: t("Định dạng tài liệu", "Định dạng tài liệu"),
      dataIndex: "criteria",
      key: "criteria",
      render: (text: any) => <div className="font-weight-5">{text}</div>,
    },
    {
      title: t("Số lượng", "Số lượng"),
      dataIndex: "count",
      key: "count",
      align: "right"
    },
  ]


  const tableColumn: TableColumnsType<any> = [
    {
      title: t("Loại đánh giá", "Loại đánh giá"),
      dataIndex: "criteria",
      key: "criteria",
      render: (text: any) => <div className="font-weight-5">{text}</div>,
    },
    {
      title: t("Số lượng", "Số lượng"),
      dataIndex: "count",
      key: "count",
      align: "right"
    },
  ]


  return <>
    <section className="section-table--chart">
      <div className="table-chart--label">
        <p className="text">{t("Thống kê khoá học", "Thống kê khoá học")}</p>
      </div>
      <Row gutter={{xs: 8, sm: 8, md: 16, lg: 16}}>
        <Col sm={{span: 12}} xs={{span: 24}} style={{marginTop: 0}}>
          <StatisticalReportCard
            chartName={t("Số lượng khóa học theo hình thức xuất bản", "Số lượng khóa học theo hình thức xuất bản")}
            content={
              <Spin spinning={loading}>
                {courseFormatUniversityList.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={createTableData(courseFormatUniversityList).dataSource}
                    columns={[
                      {
                        title: t("Trường", "Trường"),
                        dataIndex: "name",
                        key: "name",
                        render: (text: any) => <div className="font-weight-5">{text}</div>,
                      },
                      ...createTableData(courseFormatUniversityList, 'right').columns,
                      {
                        title: t("Tổng", "Tổng"),
                        dataIndex: "total",
                        key: "total",
                        render: (text: any) => <div className="font-weight-5">{text}</div>,
                        align: "right"
                      },
                    ]}
                    keyColumn="criteria"
                    height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={[
              {
                label: "Excel",
                action: () =>
                  handleExportReport(exportTableCourseFormatByUniversity, t("Số lượng khoá học theo phân công", "Số lượng khoá học theo phân công"),
                    "excel",
                    exportPayload
                  ),
              },
              {
                label: "PDF",
                action: () =>
                  handleExportReport(exportTableCourseFormatByUniversity, t("Số lượng khoá học theo phân công", "Số lượng khoá học theo phân công"),
                    "pdf",
                    exportPayload
                  ),
              },
            ]}
          />
        </Col>
        <Col sm={{span: 6}} xs={{span: 24}} style={{marginTop: 0}}>
          <StatisticalReportCard
            chartName={t("Số lượng khóa học theo khoa", "Số lượng khóa học theo khoa")}
            content={
              <Spin spinning={loading}>
                {courseByIndustry.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={courseByIndustry}
                    columns={tableColumnCourseUnit}
                    keyColumn="type"
                    height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={[
              {
                label: "Excel",
                action: () =>
                  handleExportReport(exportTableCourseByIndustry, t("Số lượng khóa học theo khoa", "Số lượng khóa học theo khoa"),
                    "excel",
                    exportPayload
                  ),
              },
              {
                label: "PDF",
                action: () =>
                  handleExportReport(exportTableCourseByIndustry, t("Số lượng khóa học theo khoa", "Số lượng khóa học theo khoa"),
                    "pdf",
                    exportPayload
                  ),
              },
            ]}
          />
        </Col>
        <Col sm={{span: 6}} xs={{span: 24}} style={{marginTop: 0}}>
          <StatisticalReportCard
            chartName={t("Số lượng bài giảng theo khoa", "Số lượng bài giảng theo khoa")}
            content={
              <Spin spinning={loading}>
                {unitByIndustry.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={unitByIndustry}
                    columns={tableColumnCourseUnit}
                    keyColumn="type"
                    height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={[
              {
                label: "Excel",
                action: () =>
                  handleExportReport(exportTableUnitFormatByIndustry, t("Số lượng bài giảng theo khoa", "Số lượng bài giảng theo khoa"),
                    "excel",
                    exportPayload
                  ),
              },
              {
                label: "PDF",
                action: () =>
                  handleExportReport(exportTableUnitFormatByIndustry, t("Số lượng bài giảng theo khoa", "Số lượng bài giảng theo khoa"),
                    "pdf",
                    exportPayload
                  ),
              },
            ]}
          />
        </Col>
      </Row>
    </section>
    <section className="section-table--chart">
      <div className="table-chart--label">
        <p className="text">{t("Thống kê số lượng học liệu", "Thống kê số lượng học liệu")}</p>
      </div>
      <Row gutter={{xs: 8, sm: 8, md: 16, lg: 16}}>
        <Col sm={{span: 6}} xs={{span: 24}} style={{marginTop: 0}}>
          <StatisticalReportCard
            chartName={t("Số lượng bài kiểm tra", "Số lượng bài kiểm tra")}
            content={
              <Spin spinning={loading}>
                {universityByTestType.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={universityByTestType}
                    columns={tableColumn}
                    keyColumn="type"
                    height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={[
              {
                label: "Excel",
                action: () =>
                  handleExportReport(exportTableUniversityTestByType, t("Số lượng bài kiểm tra", "Số lượng bài kiểm tra"),
                    "excel",
                    exportPayload
                  ),
              },
              {
                label: "PDF",
                action: () =>
                  handleExportReport(exportTableUniversityTestByType, t("Số lượng bài kiểm tra", "Số lượng bài kiểm tra"),
                    "pdf",
                    exportPayload
                  ),
              },
            ]}
          />
        </Col>
        <Col sm={{span: 6}} xs={{span: 24}} style={{marginTop: 0}}>
          <StatisticalReportCard
            chartName={t("Số lượng tài liệu tham khảo", "Số lượng tài liệu tham khảo")}
            content={
              <Spin spinning={loading}>
                {universityReferenceSource.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={universityReferenceSource}
                    columns={tableColumnQuantity}
                    keyColumn="type"
                    height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={[
              {
                label: "Excel",
                action: () =>
                  handleExportReport(exportTableReferenceSourceByType, t("Số lượng tài liệu tham khảo", "Số lượng tài liệu tham khảo"),
                    "excel",
                    exportPayload
                  ),
              },
              {
                label: "PDF",
                action: () =>
                  handleExportReport(exportTableReferenceSourceByType, t("Số lượng tài liệu tham khảo", "Số lượng tài liệu tham khảo"),
                    "pdf",
                    exportPayload
                  ),
              },
            ]}
          />
        </Col>
        <Col sm={{span: 6}} xs={{span: 24}} style={{marginTop: 0}}>
          <StatisticalReportCard
            chartName={t("Số lượng Scorm & xAPI", "Số lượng Scorm & xAPI")}
            content={
              <Spin spinning={loading}>
                {universityScormXapiUnit.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={universityScormXapiUnit}
                    columns={tableColumnQuantity}
                    keyColumn="type"
                    height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={[
              {
                label: "Excel",
                action: () =>
                  handleExportReport(exportTableUniversityScomXapiUnit, t("Số lượng Scorm & xAPI", "Số lượng Scorm & xAPI"),
                    "excel",
                    exportPayload
                  ),
              },
              {
                label: "PDF",
                action: () =>
                  handleExportReport(exportTableUniversityScomXapiUnit, t("Số lượng Scorm & xAPI", "Số lượng Scorm & xAPI"),
                    "pdf",
                    exportPayload
                  ),
              },
            ]}
          />
        </Col>
        <Col sm={{span: 6}} xs={{span: 24}} style={{marginTop: 0}}>
          <StatisticalReportCard
            chartName={t("Số lượng học liệu đa phương tiện", "Số lượng học liệu đa phương tiện")}
            content={
              <Spin spinning={loading}>
                {universityMultiMediaUnit.length > 0 ? (
                  <TableWithTotals
                    totalLabel={t("Tổng", "Tổng")}
                    data={universityMultiMediaUnit}
                    columns={tableColumnQuantity}
                    keyColumn="type"
                    height={275}
                  />
                ) : (
                  <Empty description={t("Không có dữ liệu", "Không có dữ liệu")}/>
                )}
              </Spin>
            }
            exportOptions={[
              {
                label: "Excel",
                action: () =>
                  handleExportReport(exportTableUniversityMultiMediaUnit, t("Số lượng học liệu đa phương tiện", "Số lượng học liệu đa phương tiện"),
                    "excel",
                    exportPayload
                  ),
              },
              {
                label: "PDF",
                action: () =>
                  handleExportReport(exportTableUniversityMultiMediaUnit, t("Số lượng học liệu đa phương tiện", "Số lượng học liệu đa phương tiện"),
                    "pdf",
                    exportPayload
                  ),
              },
            ]}
          />
        </Col>
      </Row>
    </section>
  </>;
};

export default ResourceTable;
